<template>
    <sub-page
        class="m-liveHostDetail"
        :title="liveData.title"
        title-align="left"
    >
        <template #prefix>
            <type-tag type="liveType" :id="liveData.status"></type-tag>
        </template>

        <div class="host-info-wrapper info-box">
            <h3>直播信息</h3>

            <div class="host-edit" v-if="isEditing">
                <el-form
                    :model="hostForm"
                    :rules="hostRules"
                    class="host-form"
                    label-width="120px"
                    size="small"
                    ref="hostForm"
                    key="hostForm"
                >
                    <el-form-item label="直播标题" prop="title">
                        <el-input v-model="hostForm.title" placeholder="请输入直播标题" clearable></el-input>
                    </el-form-item>

                    <el-form-item label="直播时间" prop="startTime">
                        <el-date-picker
                            v-model="hostForm.startTime"
                            type="datetime"
                            style="width: 225px"
                            format="yyyy-MM-dd HH:mm"
                            placeholder="请选择直播时间"
                            value-format="yyyy-MM-dd HH:mm:ss">
                        </el-date-picker>

                    </el-form-item>

                    <el-form-item label="直播简介" prop="desc">
                        <el-input type="textarea"
                                  v-model="hostForm.desc"
                                  :autosize="{ minRows: 5, maxRows: 20}"
                                  maxlength="1000"
                                  show-word-limit>
                        </el-input>
                    </el-form-item>

                    <el-form-item class="item-topic" label="直播话题" prop="topics">
                        <el-tag
                            v-for="(item, index) in hostForm.topics"
                            :key="item"
                            closable
                            size="medium"
                            @close="deleteTopic(index)">
                            {{ item }}
                        </el-tag>
<!--                        <el-input-->
<!--                            class="input-new-tag"-->
<!--                            v-if="topicInputting"-->
<!--                            v-model="topicValue"-->
<!--                            ref="topicInput"-->
<!--                            size="mini"-->
<!--                            maxlength="8"-->
<!--                            @keyup.enter.native="addTopic"-->
<!--                            @blur="addTopic"-->
<!--                        >-->
<!--                        </el-input>-->
                        <el-autocomplete
                            class="input-new-tag"
                            v-if="topicInputting"
                            v-model="topicValue"
                            ref="topicInput"
                            value-key="topicName"
                            :fetch-suggestions="getTopicList"
                            @select="addTopic"
                            @keyup.enter.native="addTopic"
                        >
                            <i slot="suffix" class="icon-cancel el-icon-circle-close" @click="cancelAddTopic"></i>
                        </el-autocomplete>
                        <el-button v-if="!topicInputting && this.hostForm.topics.length < 6" class="button-new-tag"
                                   size="mini" @click="showTopicInput" icon="el-icon-circle-plus">新话题
                        </el-button>
                    </el-form-item>

                    <el-form-item label="需要密码" prop="needPassword">
                        <el-radio-group v-model="hostForm.needPassword">
                            <el-radio :label="false">{{ $t('c.no') }}</el-radio>
                            <el-radio :label="true">{{ $t('c.yes') }}</el-radio>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item :label="$t('live.password')" prop="password" v-if="hostForm.needPassword">
                        <el-input :placeholder="$t('app.pwd')" v-model="hostForm.password"></el-input>
                    </el-form-item>

                    <el-form-item label="直播封面" prop="thumb">
                        <image-uploader
                            v-model="hostForm.thumb"
                        ></image-uploader>
                    </el-form-item>
                </el-form>
            </div>

            <div class="host-view" v-if="!isEditing">
                <div class="view-banner" v-if="liveData.id">
                    <img class="live-thumb" :src="liveData.thumb" alt="封面">
<!--                    <img v-if="liveData.thumb" class="live-thumb" :src="liveData.thumb" alt="封面">-->
<!--                    <img v-else class="live-thumb" :src="getDefaultThumb(liveData.id)" alt="封面">-->
                </div>
                <el-form
                    class="view-form"
                    label-width="120px"
                    size="small"
                >
                    <el-form-item label="直播标题">{{ liveData.title }}</el-form-item>
                    <el-form-item label="直播时间">{{ liveData.startTime | datetime }}</el-form-item>
                    <el-form-item label="直播简介">{{ liveData.desc }}</el-form-item>
                    <el-form-item class="item-topic" label="直播话题">
                        <template v-if="hostForm.topics.length">
                            <el-tag v-for="(item, index) in hostForm.topics" :key="item" size="medium">{{ item }}</el-tag>
                        </template>
                        <span v-else>无</span>
                    </el-form-item>
                    <el-form-item label="密码">{{ liveData.password || '无' }}</el-form-item>

                    <el-button class="btn-live" @click="startHost" type="danger" size="medium">
                        <p><i class="nucfont inuc-live headShake"></i><span>开播</span></p>
                    </el-button>
                </el-form>
            </div>
        </div>

        <div class="host-management" v-if="!isEditing">

            <!-- 直播数据 -->
            <live-host-count :id="liveID"></live-host-count>

            <!-- 直播签到 -->
            <live-host-sign :id="liveID"></live-host-sign>

            <!-- 直播回放 -->
            <live-host-replay :id="liveID" :live-data="liveData"></live-host-replay>
        </div>


        <div class="btn-group">
            <template v-if="isEditing">
                <el-button @click="cancelEdit" size="medium">取消</el-button>
                <el-button @click="saveHost" type="primary" size="medium" :loading="hostLoading">{{ $t('c.save') }}
                </el-button>
            </template>
            <template v-else>
                <el-button @click="isEditing = true" size="medium">编辑</el-button>
            </template>
        </div>
    </sub-page>
</template>

<script>
/**
 * todo:
 * 1、desc富文本，thumb封面
 * 2、数据统计说明
 */
import api from "@/api";
import ImageUploader from "@components/UI/ImageUploaderz";
import LiveHostCount from './Components/LiveHostCount'
import LiveHostSign from "./Components/LiveHostSign";
import LiveHostReplay from "./Components/LiveHostReplay";

export default {
    props: ['action'],

    components: {
        ImageUploader,
        LiveHostCount,
        LiveHostSign,
        LiveHostReplay
    },

    data() {
        return {
            liveID: '',
            // 进入房间的状态：add、edit、view
            initAction: '',
            // 是否在编辑中
            isEditing: false,
            hostForm: {
                title: '',
                desc: '',
                startTime: '',
                topics: [],
                needPassword: false,
                password: '',
                thumb: ''
            },
            hostRules: {
                title: [
                    {required: true, message: '请输入直播标题', trigger: 'blur'},
                    {min: 2, max: 30, message: this.$t('rule.lengthBetween', ['2', '30']), trigger: 'blur'}
                ],
                startTime: [
                    {required: true, message: '请选择直播时间', trigger: 'blur'}
                ],
                desc: [
                    {required: true, message: '请输入直播简介', trigger: 'blur'},
                    {max: 1000, message: this.$t('rule.maxLength', ['1000']), trigger: 'blur'}
                ],
                password: [
                    {required: true, message: this.$t('app.pwd'), trigger: 'blur'},
                    {min: 2, max: 30, message: this.$t('rule.lengthBetween', ['2', '30']), trigger: 'blur'}
                ],
            },
            liveData: {},
            topicValue: '',
            topicInputting: false,
            hostLoading: false,
        }
    },

    created() {
        this.liveID = this.$route.params.id
        this.initAction = this.liveID ? this.action : 'add'

        this.isEditing = this.initAction !== 'view'

        // 编辑&查看 加载数据
        if (this.liveID) {
            this.getLiveDetail()
        }
    },

    beforeDestroy() {
        this.$emit('onClose');
    },

    methods: {
        getLiveDetail() {
            this.$api.getLiveRoomInfo(this.liveID).then(res => {
                let data = {...res.package}

                data.title = data.subject
                data.topics = data.topics ? data.topics.split(',') : []

                for (let item in data) {
                    if (this.hostForm.hasOwnProperty(item)) {
                        this.hostForm[item] = data[item];
                    }
                }

                this.liveData = data

                if (!this.liveData.thumb) {
                    this.liveData.thumb = this.getDefaultThumb(this.liveData.id)
                }
            })
        },

        getTopicList(queryString, cb) {
            this.$api.getLiveTopic({
                topicsName: queryString
            }).then(res => {
                let data = res.package
                cb(data)
            })
        },

        saveHost() {
            this.$refs["hostForm"].validate((valid) => {
                if (!valid) return;

                let submitData = {...this.hostForm};

                if (!submitData.needPassword) {
                    delete submitData.password
                }
                delete submitData.needPassword

                if (submitData.topics.length) {
                    submitData.topics = submitData.topics.join()
                }

                this.hostLoading = true;

                if (this.liveID) {
                    api.editLiveRoom(this.liveID, submitData).then(res => {
                        this.success()
                    }).finally(() => this.hostLoading = false)
                } else {
                    api.addLiveRoom(submitData).then(res => {
                        this.liveID = res.package?.id
                        this.$router.replace({name: 'liveHostDetail', params: {id:this.liveID, action:'view'}})
                        this.success()
                    }).finally(() => this.hostLoading = false)
                }
            })
        },

        success() {
            this.$message.success('保存成功！')
            this.isEditing = false
            this.getLiveDetail()
        },

        startHost() {
            window.open(`/live/publish/${this.liveID}`)
        },

        addTopic() {
            if (this.topicValue.length > 20) {
                return this.$message.error('不能超过20个字符！')
            }

            if (this.topicValue &&
                !this.hostForm.topics.includes(this.topicValue) &&
                this.hostForm.topics.length < 6
            ) {
                this.hostForm.topics.push(this.topicValue);
            }

            this.topicInputting = false;
            this.topicValue = '';
        },
        cancelAddTopic() {
            this.topicInputting = false;
            this.topicValue = '';
        },
        deleteTopic(index) {
            this.hostForm.topics.splice(index, 1)
        },
        showTopicInput() {
            this.topicInputting = true
            this.$nextTick(() => {
                this.$refs.topicInput.$refs.input.focus();
            })
        },

        uploadSuccess(url) {
            this.hostForm.thumb = url
        },

        getDefaultThumb(id) {
            if (!id) return ''

            let lastNumber = String(id).substr(-1, 1)
            let imageID = lastNumber % 7  // 0~6

            let url = require(`@/assets/images/live/cover${imageID}.png`)

            return url
        },

        cancelEdit() {
            if (this.initAction === 'view') {
               this.isEditing = false
            } else {
                this.$router.back()
            }
        }
    },
}
</script>

<style scoped lang="scss">
.m-liveHostDetail {
    /deep/ > .el-main {
        padding-bottom: 40px;
    }
    /deep/ .el-input__count {
        background-color: transparent;
        bottom: 0;
    }
    /deep/ .el-card__body {
        padding-top: 8px;
    }

    /deep/ .sub-page-header {
        padding-left: 30px;
    }

    .type-tag {
        margin-right: 6px;
        vertical-align: 2px;
    }
}

.info-box {
    padding: 0 30px 20px 30px;

    > h3,
    > /deep/ h3 {
        margin-top: 15px;
        margin-bottom: 20px;
        padding-left: 10px;
        color: #666;
        font-weight: 600;
        letter-spacing: .5px;
        border-left: 4px solid $blue;
    }
}

.host-form {
    width: 700px;
}

.host-form, .view-form {
    /deep/ .el-form-item__label {
        padding-right: 15px;
    }
}

.item-topic {
    .el-tag {
        margin-bottom: 10px;

        + .el-tag {
            margin-left: 10px;
        }
    }

    .button-new-tag {
        width: 100px;
        padding: 0;
        margin-left: 10px;
        height: 28px;
        line-height: 28px;
    }

    .input-new-tag {
        width: 110px;
        margin-left: 10px;
        font-size: 12px;

        .icon-cancel {
            font-size: 15px;
            vertical-align: -2px;
            cursor: pointer;
            &:hover {
                color: $blue;
            }
        }

        /deep/ .el-input__inner {
            padding-left: 10px;
            padding-right: 20px;
        }
    }
}

.host-view {
    display: flex;
    align-items: center;
    .view-banner {
        width: 40%;
        text-align: center;
        > img {
            max-height: 360px;
        }
    }

    .view-form {
        flex: 1;
        padding-left: 20px;

        /deep/ .el-form-item__label {
            color: #888;
        }
    }
}

.btn-live {
    margin-top: 20px;
    margin-left: 50px;
    letter-spacing: 2px;
    //box-shadow: 0 2px 2px 1px #d46363;
    box-shadow: 0 0.2em 0 #bf5757, 0 0.2em 0.2em grey;

    .nucfont {
        margin-right: 5px;
        font-size: 20px;
    }

    .headShake {
        display: inline-block;
        animation: 4s ease-in-out infinite both rubber-shake;
    }
}

@keyframes rubber-shake {
    from {
        -webkit-transform: scale3d(1, 1, 1);
        transform: scale3d(1, 1, 1);
    }

    7.5% {
        -webkit-transform: scale3d(1.25, 0.75, 1);
        transform: scale3d(1.25, 0.75, 1);
    }

    10% {
        -webkit-transform: scale3d(0.75, 1.25, 1);
        transform: scale3d(0.75, 1.25, 1);
    }

    12.5% {
        -webkit-transform: scale3d(1.15, 0.85, 1);
        transform: scale3d(1.15, 0.85, 1);
    }

    16% {
        -webkit-transform: scale3d(.95, 1.05, 1);
        transform: scale3d(.95, 1.05, 1);
    }

    18% {
        -webkit-transform: scale3d(1.05, .95, 1);
        transform: scale3d(1.05, .95, 1);
    }

    20% {
        -webkit-transform: scale3d(1, 1, 1);
        transform: scale3d(1, 1, 1);
    }
}

.btn-group {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 10px 0;
    text-align: center;
    background-color: #fff;
    border-top: 1px solid #eee;
    box-shadow: 0 2px 8px #ccc;
    z-index: 1;

    button {
        letter-spacing: 4px;

        + button {
            margin-left: 15px;
        }
    }
}
</style>
